import React from 'react';
import { User } from '@apply/store/src/user/types';

export const Greeting: React.FC<{ user: User }> = ({ user }) => {
    return (
        <>
            <h1>Welcome Back, {user.firstName}</h1>
        </>
    );
};
